import React from 'react';
import { QuizPage } from '../components/QuizPage';
export function LeadSource({
  onAnswer
}: {
  onAnswer: (ans: string, dq: boolean) => void;
}) {
  return <QuizPage stepNumber={6} question="How are you currently getting most of your new patients?" options={[{
    label: 'Referrals and word of mouth'
  }, {
    label: 'Some paid ads, run by an agency'
  }, {
    label: 'Some paid ads, managed in-house'
  }, {
    label: "We've tried a lot; nothing is reliably working"
  }]} onSelect={opt => onAnswer(opt.label, !!opt.isDq)} data-id="element-150" />;
}